import {useCallback, useEffect, useState} from 'react';
import './Tooltip.sass';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

export const Tooltip = ({
  children,
  text,
  className,
  position = 'bottom',
  visible = false,
  onClickClose,
  dataQaId,
}) => {
  const [localVisible, setLocalVisible] = useState(visible);

  const onClickCloseHandler = useCallback(() => {
    setLocalVisible(false);
    onClickClose && onClickClose();
  }, []);

  useEffect(() => {
    setLocalVisible(visible);
  }, [visible]);

  return (
    <div className="create-flow_tooltip-wrapper">
      {children}
      {localVisible && (
        <div
          data-qa-id={dataQaId}
          onClick={onClickCloseHandler}
          className={`
          create-flow_tooltip-container
          ${`create-flow_tooltip-container--${position}`}
          ${className}
          `}
        >
          <div className="create-flow_tooltip-container__text">
            <p>{text}</p>
          </div>
          <CloseLineIcon ratio={0.75} />
        </div>
      )}
    </div>
  );
};
